import DecimalNumberInput from '__components/Inputs/TextInput/presets/DecimalNumber';
import { RangeInputContainer } from './styled';
import { NumberInputHandlerParams, RangeInputProps } from './types';

export const DecimalRange = ({
  step,
  value,
  width,
  placeholder,
  error,
  onChange,
}: RangeInputProps<number | null>) => {
  const min = value?.[0];
  const max = value?.[1];

  return (
    <RangeInputContainer width={width}>
      <DecimalNumberInput
        value={min}
        placeholder={placeholder}
        error={error}
        onValueChange={({ floatValue }: NumberInputHandlerParams) => {
          onChange(step, [floatValue === undefined ? null : floatValue, max]);
        }}
      />
      <DecimalNumberInput
        value={max}
        placeholder={placeholder}
        error={error}
        onValueChange={({ floatValue }: NumberInputHandlerParams) => {
          onChange(step, [min, floatValue === undefined ? null : floatValue]);
        }}
      />
    </RangeInputContainer>
  );
};
